export const CHANNELS = [
  {
    id: 'IN_APP',
    label: 'In-App',
    description: 'Message dans l’espace client',
    enabled: true,
  },
  {
    id: 'EMAIL',
    label: 'Email',
    description: 'Campagne marketing (hors emails de commande)',
    enabled: true,
    requiresMarketing: true,
  },
  {
    id: 'PUSH',
    label: 'Push',
    description: 'Notification mobile',
    enabled: false,
    soonLabel: 'Bientôt',
  },
];

export const GROWTH_STATUS_LABELS = {
  DRAFT: { label: 'Brouillon', badge: 'bg-gray-100 text-gray-700' },
  READY: { label: 'Prête', badge: 'bg-sky-100 text-sky-800' },
  SENDING: { label: 'Envoi…', badge: 'bg-amber-100 text-amber-800' },
  SENT: { label: 'Envoyée', badge: 'bg-emerald-100 text-emerald-800' },
  PARTIAL: { label: 'Partielle', badge: 'bg-orange-100 text-orange-800' },
  FAILED: { label: 'Échec', badge: 'bg-red-100 text-red-800' },
  CANCELLED: { label: 'Annulée', badge: 'bg-gray-100 text-gray-600' },
  // Notifications plateforme (legacy)
  PROGRAMMEE: { label: 'Programmé', badge: 'bg-amber-100 text-amber-800' },
  ENVOYEE: { label: 'Envoyée', badge: 'bg-emerald-100 text-emerald-800' },
  ERREUR: { label: 'Erreur', badge: 'bg-red-100 text-red-800' },
  ANNULEE: { label: 'Annulée', badge: 'bg-gray-100 text-gray-600' },
};

/** Mappe une notification plateforme vers la ligne d’historique Communication */
export function mapPlatformNotificationToHistoryRow(n) {
  const canal = String(n.canal || 'IN_APP').toUpperCase();
  return {
    id: n.id,
    source: 'platform',
    kind: 'REAL',
    status: n.statut || 'ENVOYEE',
    title: n.titre || 'Communication Clickorico',
    subject: n.meta?.sujet || null,
    channels: [canal],
    recipientCount: n.destinataires ?? 0,
    sentCount: n.statut === 'ENVOYEE' ? (n.destinataires ?? 0) : 0,
    failedCount: n.statut === 'ERREUR' ? (n.destinataires ?? 0) : 0,
    createdAt: n.dateEnvoi || n.createdAt,
    textContent: n.message || '',
    commercantId: n.commercantId ?? null,
  };
}

export const TIER_LABELS = {
  INCLUS: 'Inclus',
  PLUS: 'Plus',
  PREMIUM: 'Premium',
};
